
import { defineComponent, ref, reactive, computed, defineAsyncComponent, onMounted } from 'vue'
import { useStore } from 'vuex'
import CbimSteps from '@/components/CbimSteps/CbimSteps.vue'
import { getUrlQuery } from '@/utils/utils'
import { useI18n } from 'vue-i18n'
import commonService from '@/services/commonService'
import { message } from 'ant-design-vue'

interface Paylaod {
    active: number
    accountVal?: string
    verifyCodeVal?: string
    countryCode?: string
    type?: string
    email?: string
}
export default defineComponent({
    name: 'Signin',
    components: {
        CbimSteps,
        InputAccountStep: defineAsyncComponent(() => import('@/components/CbimSteps/InputAccountStep.vue')),
        SecurityVerificationStep: defineAsyncComponent(() => import('@/components/CbimSteps/SecurityVerificationStep.vue')),
        SetPasswordStep: defineAsyncComponent(() => import('@/components/CbimSteps/SetPasswordStep.vue')),
        SetUsername: defineAsyncComponent(() => import('@/components/CbimSteps/SetUsername.vue')),
    },
    setup() {
        const { t, locale } = useI18n()
        const currentLanguage = locale.value
        const currentStep = ref()
        const stepsTitle = reactive([t('message.shuruzhanghao'), t('message.anquanyanzheng'), t('message.shezhimima'), t('message.shezhinicheng')])
        
        const showErrorPage = ref(false)
        const errorMessage = ref('')
        
        const store = useStore()
        const account = ref()
        const verifyCode = ref()
        const email = ref()
        const countryCode = ref(store.state.countryCode || '+86')
        const type = ref('')
        const checked = ref(false)
        
        // 检查是否有emailCode参数，如果有则直接跳转到第三步并验证
        onMounted(async () => {
            const emailCode = getUrlQuery('emailCode')
            if (emailCode) {
                try {
                    // 调用邮箱验证接口
                    const response: any = await commonService.verifyEmail({ emailCode: emailCode as string })
                    if (response.code === '200') {
                        // 验证成功，跳转到第三步（SetPasswordStep），并将返回的mobile值和email值保存
                        if (response.data && response.data.mobile) {
                            account.value = response.data.mobile // 使用返回的mobile值
                        }
                        if (response.data && response.data.email) {
                            email.value = response.data.email // 使用返回的email值
                        }
                        currentStep.value = 2 // 第三步的索引是2
                    } else {
                         // 验证失败，显示错误页面
                         console.log(312312312321,response)
                         showErrorPage.value = true
                         errorMessage.value = response.message || t('message.emailVerificationFailedRetry')
                     }
                } catch (err: any) {
                    // 验证失败，显示错误页面
                    console.log(31231, err)
                    showErrorPage.value = true
                    errorMessage.value = err.message || t('message.emailVerificationFailedRetry')
                }
            } else {
                // 没有emailCode参数，按正常流程处理
                let active: number = 0
                if (getUrlQuery('active')) {
                    active = JSON.parse(getUrlQuery('active') as string)
                }
                currentStep.value = active
            }
        })

        const goToHome = () => {
            window.location.href = '/'
        }

        const currentComponent = computed(() => {
            const componentList = ['InputAccountStep', 'SecurityVerificationStep', 'SetPasswordStep', 'SetUsername']
            return componentList[currentStep.value]
        })

        const handleNextProcess = ({ accountVal, active, verifyCodeVal, countryCode: receivedCountryCode, type: receivedType, email: receivedEmail }: Paylaod) => {
            if (accountVal && accountVal !== '') {
                account.value = accountVal
            }
            if (verifyCodeVal && verifyCodeVal !== '') {
                verifyCode.value = verifyCodeVal
            }
            if (receivedCountryCode && receivedCountryCode !== '') {
                countryCode.value = receivedCountryCode
            }
            if (receivedType && receivedType !== '') {
                type.value = receivedType
            }
            if (receivedEmail !== undefined) {
                email.value = receivedEmail
            }
            currentStep.value = active
        }
        const handleAgreement = () => {
            window.location.href = (process.env.VUE_APP_DEPLOY === 'development' ? '/agreement' : '/passport/agreement') + (currentLanguage == 'en' ? `?lang=${currentLanguage}` : '')
        }
        return {
            currentLanguage,
            currentComponent,
            currentStep,
            stepsTitle,
            account,
            verifyCode,
            email,
            countryCode,
            type,
            checked,
            handleNextProcess,
            handleAgreement,
            showErrorPage,
            errorMessage,
            goToHome
        }
    }
})
